import {Keys} from './redux/Datastore'
import {Actions} from './redux/Actions'

export class SitemapUtils{
    public static fetch_sitemap_url(id_segment:number, id_customer:number, customer:string, dispatch:any){
        dispatch(Actions.ACTION_SET_SITEMAP_URL, null)
        //let url = "https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/maptiles/osuwmc/13/36/sitemap/0-0-0.png"
        let sitemap_url = "sitemap/sitemap.html?_ _ _"
        //let url="sitemap/geojson/osuwmc.txt"
        let geojson_url = "sitemap/geojson/" + customer + ".txt"
        $.ajax({
            url:geojson_url,
            type:'HEAD',
            error: function()
            {
                dispatch(Actions.ACTION_SET_SITEMAP_URL, null) //sitemap geojson does not exist
            },
            success: function()
            {
                dispatch(Actions.ACTION_SET_SITEMAP_URL, sitemap_url) //sitemap geojson exists
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/ts/SitemapUtils.ts